const translations = {
  Upload: "Subir",
  "Select Header": "Seleccionar encabezado",
  "Map Columns": "Mapear columnas",
  "Expected Column": "Columnas esperadas",
  Required: "Requerido",
  "Drop your file here": "Suelta tu archivo aquí",
  or: "o",
  "Browse files": "Examinar archivos",
  "Download Template": "Descargar plantilla",
  "Only CSV, XLS, and XLSX files can be uploaded": "Solo se pueden subir archivos CSV, XLS y XLSX",
  "Select Header Row": "Seleccionar fila de encabezado",
  "Select the row which contains the column headers": "Selecciona la fila que contiene los encabezados de las columnas",
  "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": " Solo se importará la primera hoja (&quot;{{sheet}}&quot;) del archivo de Excel. Para importar varias hojas, sube cada hoja individualmente.",
  "Cancel": "Cancelar",
  "Continue": "Continuar",
  "Your File Column": "Tu columna del archivo",
  "Your Sample Data": "Tus datos de muestra",
  "Destination Column": "Columna de destino",
  "Include": "Incluir",
  "Submit": "Enviar",
  "Loading...": "Cargando...",
  "Please include all required columns": "Por favor incluye todas las columnas requeridas",
  "Back": "Atrás",
  "- Select one -": "- Selecciona uno -",
  "- empty -": "- vacío -",
  "Import Successful": "Importación exitosa",
  "Upload Successful": "Se ha subido con éxito",
  "Done": "Listo",
  "Upload another file": "Subir otro archivo",
};

export default translations;
